import { ref, computed } from 'vue'
import { isMobileDevice } from "@/utils/utils";
export function useMixinMobileDevice() {

    const mobileDevice = ref(false)
    const Orientation = ref("nolandscape");

    mobileDevice.value = isMobileDevice();
    if (mobileDevice.value) {
        if (screen.orientation.type.startsWith("landscape")) {
            console.log("横屏");
            Orientation.value = "landscape";
        } else {
            Orientation.value = "nolandscape";
            console.log("竖屏");
        }
        if (screen.orientation) {
            screen.orientation.onchange = function () {
                if (screen.orientation.type.startsWith("landscape")) {
                    console.log("横屏");
                    // enterFullscreen();
                    Orientation.value = "landscape";
                } else {
                    // exitFullscreen();
                    Orientation.value = "nolandscape";
                    console.log("竖屏");
                }
            };
        } else {
            window.addEventListener("resize", function () {
                if (window.innerWidth > window.innerHeight) {
                    document.querySelector(".rotate-device").style.display =
                        "none";
                } else {
                    document.querySelector(".rotate-device").style.display =
                        "block";
                }
            });
        }
    }

    return {
        mobileDevice,
        Orientation
    }
}